import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: {
    value: string;
    label: string;
  }[] = [{
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-white/5 text-ivory border-gold/40' : 'bg-white text-ink border-gold-soft';
  const label = tone === 'dark' ? 'text-gold' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-4" role="timer" aria-live="off" aria-label={`La oferta termina en ${hours} horas ${minutes} minutos ${seconds} segundos`} data-id="element-91" data-mp="3262r69o6abfr">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-92" data-mp="15a4yk84kdre0" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className={`font-serif ${isLarge ? 'text-3xl sm:text-4xl' : 'text-xl'} ${tone === 'dark' ? 'text-gold/60' : 'text-gold'}`} data-id="element-93" data-mp="y0wr1bdwlefq">
              :
            </span>}
          <div className={`border text-center tabular-nums ${box} ${isLarge ? 'px-5 py-4 sm:px-8 sm:py-5 min-w-[82px] sm:min-w-[108px]' : 'px-3 py-2.5 min-w-[62px]'}`} data-id="element-94" data-mp="17qgfqxoas2ii">
            <div className={`font-serif leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-xl'}`} data-id="element-95" data-mp="a3r55zfj4hl1">
              {unit.value}
            </div>
            <div className={`uppercase tracking-[0.28em] mt-2 ${label} ${isLarge ? 'text-[10px]' : 'text-[8px]'}`} data-id="element-96" data-mp="o0nwe1zk812g">
              {unit.label}
            </div>
          </div>
        </React.Fragment>)}
    </div>;
}